export default "__VITE_ASSET__DmLYyYzh__"